import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const weaponSupremacyModule = namespace('weaponSupremacies');
let CharactersWeaponSupremacies = class CharactersWeaponSupremacies extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Weapon Supremacies';
    }
    created() {
        this.fetchWeaponSupremacies();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.weaponSupremacies)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(weaponSupremacy => ({
            ...weaponSupremacy,
            id: weaponSupremacy.name,
            isExpandable: weaponSupremacy.description
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    weaponSupremacyModule.State
], CharactersWeaponSupremacies.prototype, "weaponSupremacies", void 0);
__decorate([
    weaponSupremacyModule.Action
], CharactersWeaponSupremacies.prototype, "fetchWeaponSupremacies", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersWeaponSupremacies.prototype, "isInHandbook", void 0);
CharactersWeaponSupremacies = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersWeaponSupremacies);
export default CharactersWeaponSupremacies;
